<template>
	<div id="app">
		<!-- <img src="./assets/logo.png"> -->
		<router-view />
	</div>
</template>

<script>
	import Cookies from 'js-cookie'
	import axios from 'axios';
	export default {
		name: 'App',
		data() {
			return {

			}
		},
		//判断mf_service_ticket是否还有效
		created() {
			
		},
		watch: {
			$route(to, from) { //to:即将要跳转到的页面   from:即将离开的页面
				if (Cookies.get('mf_service_ticket') === undefined) {
					if (to.path.split('/')[1] === 'people') {
						axios.post("https://sso.mfcad.com/login/jwtuserinfo", {}).then(function(res) {
							if(res.data.status<0){
								var url = window.location.href;
								if (url.indexOf("?") > -1) {
									url = url.split('?');
									if (url[1].split('=')[0] == 'service_ticket') {
										Cookies.set('mf_service_ticket', url[1].split('=')[1].split('/')[0],{expires: 14});
										var mf_service_ticket = url[1].split('=')[1].split('/')[0];
									}
								}
								location.href = "https://sso.mfcad.com/login/islogin?guid=3&from_url=" + url;
							}
						});
					} else if (to.path === '/') {
						this.$router.push('/')
					}
				}
			}
		},
	}
</script>

<style>
	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
		margin-top: 60px;
	}
	@media screen and (-ms-high-contrast: active),(-ms-high-contrast: none) {
		#app {
			-webkit-font-smoothing: antialiased;
			-moz-osx-font-smoothing: grayscale;
			text-align: center;
			color: #2c3e50;
			margin-top: 60px;
			font-family: 'Microsoft YaHei';
		}
	}
</style>



// WEBPACK FOOTER //
// src/App.vue